// extracted by mini-css-extract-plugin
export default {"followButton":"VQ-z","followCount":"WQ-z","textStyle":"XQ-z"};